import * as React from "react";
import { render } from "../../common/reactUtils";
import { PopUpModal } from "./popUpModalHandler";

export const initialize = () => render(<PopUpModal />, "#js-react-popup-app");
